import React from 'react';

import MultiPageForm from "../Base/ReactMultiPageForm";
import ChildOutcomesTableReviewOnly2 from "./ChildOutcomesTableReviewOnly2";
import CollapsiblePanelWrapper from "../UI/ReactCollapsiblePanelWrapper";
import ReactTooltip from "react-tooltip";
import {deleteOutcome, getChildOutcomes} from "root/DataFunctions/OutcomeDataFns";
import {
	getDataFromResponse,
	getNamedCustomDataFromResponse,
	getNumRowsFromResponse
} from "root/DataFunctions/BaseDataFns";
import {checkError} from 'root/DataFunctions/BaseDataFns'
import SpinnerDiv from "ui/SpinnerDiv";

export default class ChildOutcomes2 extends MultiPageForm
{
	constructor(props) 
	{
		super(props);

		this.state.child_id = this.props.child_id ;
		this.state.loading = true ;
		this.state.data = {} ;
		this.state.ofr_id =  this.props.ofr_id ;
		this.state.modifyRecordId = 0 ;
		this.state.mode = this.props.mode ;
		this.state.addMode = false ;
		
		this.keyCount = 1 ;

		this.doUpdateUI = this.doUpdateUI.bind(this) ;
		this.doUpdateUIOnClose = this.doUpdateUIOnClose.bind(this) ;
		this.onDelete = this.onDelete.bind(this) ;
		this.onModify = this.onModify.bind(this) ;
		this.onModifyCancel = this.onModifyCancel.bind(this) ;
		this.onUpdate = this.onUpdate.bind(this) ;
		this.onClose = this.onClose.bind(this) ;
		this.onConfirmClose = this.onConfirmClose.bind(this) ;
		this.onCancelAdd = this.onCancelAdd.bind(this) ;
		this.onAddComplete = this.onAddComplete.bind(this) ;

		this.getData () ;
	}

	componentDidUpdate()
	{
		ReactTooltip.rebuild();
	}

	getYearDescForTerm ( row )
	{
		let desc = '' ;

		let term = row.description ;

		if ( row.description == null )
		{
			desc = "No Term" ;
		}
		else if ( row.description.length < 6 )
		{
			let yr = +row.year_start + 1 ;
			desc = row.description + ' ' + yr;
		}
		else if ( row.description.substr(0,6) == 'Autumn' )
		{
			desc = row.description + ' ' + row.year_start;
		}
		else
		{
			let yr = +row.year_start + 1 ;
			desc = row.description + ' ' + yr;
		}

		return desc ;
	}

	safeTextField (displayText)
	{
		if ( displayText != null )
		{
			displayText = displayText.replace(/\\r/g, "\r");
			displayText = displayText.replace(/\\n/g, "\n");
		}

		return displayText ;
	}

	makeSafe ( rec )
	{
		rec.description = this.safeTextField (rec.description) ;
		rec.action_and_provision = this.safeTextField (rec.action_and_provision) ;
		rec.actual_outcome = this.safeTextField (rec.actual_outcome) ;

		return rec ;
	}

	/**
	 * get the date before nofMonths for a given {@param date}
	 * @param {Date} date
	 * @param {Number} nofMonths no of months to get date before
	 * @returns {Date} date before nofMonths months
	 */
	getDateMonthsBefore(date,nofMonths)
	{
		const thisMonth = date.getMonth();

		// set the month index of the date by subtracting nofMonths from the current month index
		date.setMonth(thisMonth - nofMonths);

		// When trying to add or subtract months from a Javascript Date() Object which is any end date of a month,
		// JS automatically advances your Date object to next month's first date if the resulting date does not exist in its month.
		// For example when you add 1 month to October 31, 2008 , it gives Dec 1, 2008 since November 31, 2008 does not exist.
		// if the result of subtraction is negative and add 6 to the index and check if JS has auto advanced the date,
		// then set the date again to last day of previous month
		// Else check if the result of subtraction is non negative, subtract nofMonths to the index and check the same.

		if ((thisMonth - nofMonths < 0) && (date.getMonth() != (thisMonth + nofMonths)))
		{
			date.setDate(0);
		}
		else if ((thisMonth - nofMonths >= 0) && (date.getMonth() != thisMonth - nofMonths))
		{
			date.setDate(0);
		}
		return date;
	}

	isInDateWindow ( ddmmyyyy )
	{
		const now = new Date() ;

		const then = this.getDateMonthsBefore( now, 3 ) ;

		const parts = ddmmyyyy.split('-');

		const d = new Date(parts[0], parts[1] - 1, parts[2]);

		if ( then.getTime() < d.getTime() )
		{
			return true ;
		}
		else
		{
			return false ;
		}
	}

	getData()
	{
		const ofr_id = this.props.ofr_id == null ? 'latest' : this.props.ofr_id ;

		getChildOutcomes( this.props.child_id, ofr_id, this.props.authToken, (response) =>
		{
			const data = getDataFromResponse( response ) ;
			const numRows = getNumRowsFromResponse( response ) ;

			const cleanData = numRows > 0  ? data.map(rec => {
				return this.makeSafe(rec)
			}) : [] ;

			const activeData = numRows > 0  ? cleanData.filter(rec => {
				return rec.date_achieved == null || (rec.date_achieved !== null  && ( rec.outcome_review_id !==  null && this.isInDateWindow ( rec.date_achieved )));
			}) : [] ;

			const inactiveData = numRows > 0  ? cleanData.filter(rec => {
				return rec.date_achieved != null  && ( rec.outcome_review_id == null || !this.isInDateWindow ( rec.date_achieved )) ;
			}) : [] ;

			const ofr = getNamedCustomDataFromResponse( response, 'ofr' );

			this.setState({loading: false, data: activeData, archiveData: inactiveData, ofr: ofr, mode: this.props.mode, modifyRecordId: 0});

		})
	}

	// This function creates the review record structure from the child's template and returns the data
	// created ready to e displayed on the forms
	updateTargetRecord ( updateData, operation ) 
	{
		const data = { plan_data: updateData } ;
		
    	$.ajax({
  		  type: 'PUT',
  		  url: Globals.APIFolder + '/children/' + this.props.child_id + '/outcomes/' + updateData.cpp_id,
  		  data: data,
  		  async: false,
  		  success:(data)=>{
  			  
  			      if ( checkError(data) )
				  {
						var status = data.status ;

						var doUpdateUI = this.doUpdateUI ;
						var onDelFunc = this.props.onDelete;
						var delid = updateData.cpp_id;
						var op = operation ;
						var d = updateData ;

						bootbox.alert({ 
						  size: "large",
						  title: "Operation completed",
						  message: "The record has been saved. Click OK to continue.", 
						  callback: function()
						  { 
							  if ( op == 'close')
							  {
								  if ( onDelFunc != null )
								  {
									  onDelFunc ( delid ) ;					  
								  }
							  }
							  else
							  {
								  if ( op == 'modify')
								  {
									  doUpdateUI ( updateData );
								  }
							  }

						  }
						})
				  }
  		  },
  		  error:function(jqXHR, textStatus, error){
			  handleAjaxError ( jqXHR, textStatus, error ) ;
  		  }
  		});
	}

	// This function creates the review record structure from the child's template and returns the data
	// created ready to e displayed on the forms
	deleteTargetRecord ( cpp_id )
	{
		deleteOutcome( this.props.child_id, cpp_id, this.props.authToken, (response) =>
		{
			generalBootboxAlertWithCallback (
				"Operation completed",
				"The record has been deleted. Click OK to continue.",
				this.onDeleteComplete.bind( this, cpp_id ) );
		})
	}

	closeTargetRecord ( updateData, operation ) 
	{
		var data = { plan_data: updateData } ;
		
    	$.ajax({
  		  type: 'PUT',
  		  url: Globals.APIFolder + '/children/' + this.props.child_id + '/outcomes/' + updateData.cpp_id,
  		  data: data,
  		  async: false,
  		  success:(data)=>{
			  if ( checkError(data) )
			  {
				  generalBootboxAlertWithCallback(
					  "Operation completed",
					  "The record has been saved. Click OK to continue.",
					  this.doUpdateUIOnClose.bind(this, updateData));
			  }
  		  },
  		  error:function(jqXHR, textStatus, error){
			  handleAjaxError ( jqXHR, textStatus, error ) ;
  		  }
  		});
	}

	onClose ( cpp_id )
	{
		const curMode = this.state.mode ;

		this.setState ({ modifyRecordId: cpp_id, mode: 'close', prevMode: curMode }) ;		
	}
	
	onModify ( cpp_id )
	{
		// One of the rows had had a modify request

		const curMode = this.state.mode ;

		this.setState ({ modifyRecordId: cpp_id, mode: 'modify', prevMode: curMode }) ;		
	}
	
	onModifyCancel ( cpp_id )
	{
		this.setState ({ modifyRecordId: 0, mode: this.state.prevMode }) ;
	}

	buttonElement ( buttonText, clickHandler )
	{
        return React.createElement('button', { id: 'getButtonReact', type: 'button', className: 'btn btn-primary', onClick: clickHandler }, buttonText) ;
	}
		
	onCancelAdd() 
	{
		this.setState ({ mode: this.state.prevMode }) ;
	}

	onAddComplete()
	{
		this.setState ({ addMode: false }) ;
	}

	onAdd() 
	{
		// var curMode = this.state.mode ;

		this.setState ({ addMode: true } ) ;
	}

	onCancelAdd()
	{
		this.setState ({ addMode: false }) ;
	}

	buttonRow()
	{
		var lineList = [] ;

		if ( this.props.allowChange != false )
		{
			if ( this.state.mode == 'edit' || this.state.mode == 'create' || this.state.mode == 'qa' )
			{
				lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'col-md-8', style: { paddingLeft: '0px', paddingTop: '10px' }},
						React.createElement('button', { id: 'AddButton', type: 'button', className: 'btn btn-info', style: { float: 'left' } , onClick: this.onAdd.bind(this) }, 'Add a new Target'))) ;
	
				lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-4', style: { paddingRight: '0px'}})) ;
				
			} 
		}
		
		return React.createElement('div', { key: this.keyCount++, className: 'row'}, 
				React.createElement ( 'div', { key: this.keyCount++, className: 'panel-body', style: { paddingTop: '0px'}} , lineList)) ;		
	}

	onDeleteComplete ( recordId )
	{
		const newData = this.state.data.filter ((rec) =>
		{
			return rec.cpp_id != recordId ;
		}) ;

		this.setState ( { data: newData, mode: 'edit' }) ;
	}

	onDelete ( recordId )
	{
		this.deleteTargetRecord( recordId ) ;
	}

	doUpdateUI (record)
	{
		this.getData() ;
	}

	doUpdateUIOnClose ( record )
	{
		var newData = [] ;

		var recordId = record.cpp_id ;
		
		for (var i = 0; i < this.state.data.length; i++) 
		{ 
		    if ( this.state.data[i].cpp_id == recordId )
	    	{
	    		var newrec = this.state.data[i] ;
				
				newrec.actual_spend = record.actual_spend ;
				newrec.dmy_date_achieved = record.dmy_date_achieved;

		    	newData.push ( newrec ); 
	    	}
	    	else
	    	{
	    		var newrec = this.state.data[i] ;
				
		    	newData.push ( newrec ); 
	    	}
		}	
		
		var next = this.state.prevMode ;
		
		this.setState ( { data: newData, modifyRecordId: 0, mode: 'edit' }) ;		
	}
	
	onUpdate ( record )
	{
		this.updateTargetRecord ( record, 'modify' ) ;
	}
	
	onConfirmClose ( record )
	{
		this.closeTargetRecord ( record, 'close' ) ;
	}

	isTeacher()
	{
		if ( this.props.user_type == 5)
		{
			return true ;
		}
		else
		{
			return false ;
		}
	}

	instructionsRow()
	{
		var lineList = [] ;

		let text = "Still loading ... " ;

		const textStyleCompleted = { fontSize: '14px', fontWeight: 'bold', color: '#06a957' } ;
		const textStyle = { fontSize: '14px', fontWeight: 'bold', color: '#a94442' } ;
		const textStyleBlue = { fontSize: '16px', color: '#2f71aa' } ;

		if ( this.state.ofr != null )
		{
			const review_term = this.getYearDescForTerm( this.state.ofr ) ;

			switch ( this.state.ofr.status )
			{
				case "1":
					text = "This pupil's outcomes are now due to be reviewed again for the " + review_term + " term." ;
					lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;

					if ( this.state.data.length == 0 )
					{
						text = "There are currently no outcomes set. Please ensure that you create some in accordance with the published guidelines.";
						lineList.push(React.createElement('p', {key: this.keyCount++, style: textStyle}, text));
					}
					else
					{
						text = "Please review the outcomes below and ensure that they are current, and in accordance with the published guidelines.";
						lineList.push(React.createElement('p', {key: this.keyCount++, style: textStyle}, text));
					}

					break ;
				case "2":

					if ( this.isTeacher())
					{
						text = "The latest review term is " + review_term + " and you have updated and submitted thie pupil's outcomes for review by the Virtual School." ;
						lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyleCompleted }, text)) ;
						text = "You will receive a notification when the review is complete.";
						lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyleCompleted }, text)) ;
						break ;

					}
					else
					{
						text = "The latest review term is " + review_term + " and this pupil's outcomes have been updated and submitted by their designated teacher." ;
						lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
						text = "Please review the outcomes and approve or reject them using the buttons below. If you wish to return later, just click the 'Return to Home Page' button to leave the status of this review unchanged.";
						lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
						break ;
					}
					break ;

				case "3":
					text = "This pupil's outcomes have been reviewed by the Virtual School Head and need some more attention. The reason for this is shown below" ;
					lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
					lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyleBlue }, this.state.ofr.reason_for_rejection)) ;
					break ;
				case "4":
					text = "The latest review term is " + review_term + " and this pupil's outcomes are up to date and have been approved by the Virtual School Head. Thank You." ;
					lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyleCompleted }, text)) ;
					break ;
				default:
					text = "This pupil's outcomes are now due to be reviewed again for " + review_term + "." ;
					lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
					text = "Please review the outcomes below and ensure that the outcomes for the child are current, according to the published guidelines." ;
					lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
					break ;
			}
		}
		else
		{
			if ( this.state.data.length == 0 )
			{
				text = "This pupil does not yet have any outcomes set." ;
				lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
				text = "Please create appropriate outcomes for the pupil in accordance with the published guidelines." ;
				lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
			}
			else
			{
				text = "This pupil is not currently subject to an outcome review request." ;
				lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
				text = "Please create outcomes for the child according to the published guidelines." ;
				lineList.push (React.createElement ( 'p', { key: this.keyCount++ , style: textStyle }, text)) ;
			}
		}

		return React.createElement('div', { key: this.keyCount++, className: 'panel panel-default'},
			React.createElement ( 'div', { key: this.keyCount++ , style: { margin: '15px' } }, lineList));
	}

	tableRow ()
	{
		return React.createElement ( 'div', { key: 'OutcomesTableRow', className: 'row' } ,
			React.createElement ( ChildOutcomesTableReviewOnly2, {
				authToken: this.props.authToken,
				allowChange: this.props.allowChange,
				ofr_id: this.state.ofr_id,
				ofr: this.state.ofr,
				user_type: this.props.user_type,
				child_id: this.props.child_id,
				key: 'OutcomesTable',
				mode: this.state.mode,
				data: this.state.data,
				loading: this.state.loading,
				onDelete: this.onDelete,
				onUpdate: this.onUpdate,
				addMode: this.state.addMode,
				onClose: this.onClose,
				onConfirmClose: this.onConfirmClose,
				onModify: this.onModify,
				onModifyCancel: this.onModifyCancel,
				onCancelAdd: this.onCancelAdd,
				onAddComplete: this.onAddComplete,
				showEmptyMessage: !this.props.showInstructions,
				modifyRecordId: this.state.modifyRecordId,
				displayErrors: this.state.displayErrors,
				extended: this.props.extended,
				isSen: this.props.isSen,
				isPost16: this.props.isPost16,
			}));
	}

	archiveRow ()
	{
		return React.createElement ( 'div', { key: 'OutcomesTableRowArchive', className: 'row' } ,
			React.createElement ( CollapsiblePanelWrapper, { id: 'archive', title: 'Click to show completed Outcomes'},
				React.createElement ( ChildOutcomesTableReviewOnly2, {
					authToken: this.props.authToken,
					ofr_id: this.state.ofr_id,
					ofr: this.state.ofr,
					user_type: this.props.user_type,
					child_id: this.props.child_id,
					key: 'OutcomesTableArchive',
					mode: this.state.mode,
					data: this.state.archiveData,
					loading: this.state.loading,
					onDelete: this.onDelete,
					onUpdate: this.onUpdate,
					onClose: this.onClose,
					onConfirmClose: this.onConfirmClose,
					onModify: this.onModify,
					onModifyCancel: this.onModifyCancel,
					onCancelAdd: this.onCancelAdd,
					onAddComplete: this.onAddComplete,
					showEmptyMessage: !this.props.showInstructions,
					modifyRecordId: this.state.modifyRecordId,
					displayErrors: this.state.displayErrors,
					extended: this.props.extended,
					isSen: this.props.isSen,
					isPost16: this.props.isPost16,
				})));
	}

	render()
    {
		this.keyCount=0;

    	if ( this.state.loading === true )
    	{
	        return <SpinnerDiv />;
    	}
    	else
    	{
			const showLegacyMessage = this.props.allowChange === false ;

			return (
				<div key='ReactChildOutcomesPanel' className='panel panel-default'>
					<div key='ReactChildOutcomesPanelBody' className='panel-body'>
						{ showLegacyMessage === true && <div style={{fontSize: 'larger', color: 'var(--s360-icon-red)', textAlign: 'center'}}>This section is shown for reference purposes now and cannot be updated</div> }
						{ showLegacyMessage === true && <div style={{fontSize: 'larger', color: 'var(--s360-icon-red)', textAlign: 'center'}}>Please complete the TARGETS section instead</div> }
						{ this.props.showInstructions === true && this.instructionsRow() }
						{ this.tableRow() }
						{ this.state.addMode === false && this.buttonRow()}
						{ this.archiveRow() }
						<ReactTooltip key='tooltipOutcomes' className='tool-class'/>
						{ this.props.mode !== 'qa' && this.navFormRow()}
					</div>
				</div>
			)
    	}
    }
};